import { SupportedPlugins } from 'Core/PluginCore/PluginsManager'
import { UseCaseTypes } from 'Types/Tasks.types'

export enum DifficultyLevel {
    Easy = 'easy',
    Medium = 'medium',
    Hard = 'hard',
}

export const DisabledPluginsMap: Record<UseCaseTypes, (keyof typeof SupportedPlugins)[]> = {
    [UseCaseTypes.SFT_GENERATION_RESPONSE_GENERATION]: [],
    [UseCaseTypes.SFT_GENERATION_RESPONSE_GENERATION_RATING_USECASE]: [],
    [UseCaseTypes.RLHF_RATING_RESPONSE_RATING]: [],
    [UseCaseTypes.SFT_GENERATION_RESPONSE_GENERATION_SUMMARISATION_USECASE]: [],
    [UseCaseTypes.TEXT_ANNOTATION]: [],
    [UseCaseTypes.CUSTOM]: ['Plagiarism', 'Live Feedback'],
    [UseCaseTypes.JSON_ANNOTATION]: [],
    [UseCaseTypes.MODEL_CONVERSATIONS]: [],
    [UseCaseTypes.MODEL_CONVERSATIONS_V2]: [],
    [UseCaseTypes.AGENTIC_TRAJECTORY_CREATION]: [],
    // These will not be supported through plugins panel but can be used in python script directly
    [UseCaseTypes.CUSTOM_INTERFACE]: ['Plagiarism', 'AI Detection'],
    [UseCaseTypes.ROBOTICS]: ['Plagiarism', 'AI Detection'],
}
